<div class="admin-custom-scripts-wrapper">
    <div class="row">
        <div class="col-md-6">
            <div class="page-title" translate="scriptManagement"></div>
        </div>
        <div class="col-md-6" *ngIf="dealers.length > 1">
            <div class="float-right">
                <div class="title-dealer" translate="dealerships"></div>
                <div class="dealer-select">
                    <select id="dealer-select" class="form-control"
                            [(ngModel)]="selectedDealerId"
                            (change)="onDealerSelect()">
                        <option *ngFor="let dealer of dealers" [ngValue]="dealer.id">
                            {{dealer.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="divider"></div>

    <div class="admin-custom-scripts" [ngBusy]="{busy: busy, delay: 200}">
        <div class="row">
            <div class="col-md-12">
                <div class="filter-row">
                    <div class="form-row form-row-inline">
                        <label translate="adminCustomScripts_languageSelection"></label>
                        <select class="form-control language-select" [(ngModel)]="selectedLanguage" (change)="onFilterChange()">
                            <option *ngFor="let option of languages" [ngValue]="option.value" [translate]="option.labelKey"></option>
                        </select>
                    </div>
                </div>

                <kendo-grid [sortable]="true" [height]="300" [pageSize]="pageSize"
                            [filterable]="false" [data]="gridView" [pageable]="true"
                            (pageChange)="pageChange($event)" [skip]="skip"
                            (sortChange)="sortChange($event)" [sort]="sort">
                    <kendo-grid-column field="scriptTypeLabel" title="{{ 'adminCustomScripts_scriptSelection' | translate }}">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <a (click)="editScriptItem(dataItem)">{{dataItem.scriptTypeLabel}}</a>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="createDate" title="{{ 'createDate' | translate }}" width="240">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>{{dataItem.createDate | localeDate}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="createdByFullName" title="{{ 'createBy' | translate }}" width="240">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>{{dataItem.createdByFullName || dataItem.createdBy}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        <kendo-pager-info></kendo-pager-info>
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
    </div>
</div>
